import { BookV1 } from '@ilteducation/content-registry-types';
import { useQuery } from '@tanstack/vue-query';
import { Ref } from 'vue';
import { getDuplicateBooks } from '@/data-provider/books';

export const useDuplicateBooks = (book: BookV1): { books: Ref<BookV1[]> } => {
  const { data } = useQuery<BookV1[]>({
    queryKey: ['duplicate-books', book.id],
    queryFn: async () => getDuplicateBooks(book),
    initialData: [],
  });

  return {
    books: data,
  };
};
